import React from "react";
import { cn } from "../../../lib/utils";
import { FOCUS_RING } from "./classes";

/**
 * The black selection bar of the wireframe: "64 selected · Add tag · Remove tag ·
 * Change stage · Add to sequence · Export selected". Inline above the table, NOT sticky:
 * `<main>` is the scroller (`overflow-auto`), so `position: sticky` inside it never sticks.
 *
 * `actions`: `[{key, label, onClick, testId, disabled?}]`
 */
export default function BulkActionBar({ countLabel, actions, extra, testId }) {
  return (
    <div data-testid={testId} role="toolbar" aria-label={countLabel}
      className="flex flex-wrap items-center gap-x-1 gap-y-2 rounded-2xl bg-eh-ink px-5 py-3 text-sm text-eh-bg">
      <span className="font-semibold mr-3">{countLabel}</span>
      {actions.map((a, i) => (
        <React.Fragment key={a.key}>
          {i > 0 && <span aria-hidden="true" className="text-eh-bg/60">·</span>}
          <button type="button" onClick={a.onClick} disabled={a.disabled} data-testid={a.testId}
            className={cn("rounded-full px-2 py-0.5 hover:underline disabled:opacity-50", FOCUS_RING, "focus-visible:ring-offset-eh-ink")}>
            {a.label}
          </button>
        </React.Fragment>
      ))}
      {extra}
    </div>
  );
}
